import { useState, useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { useInvestorReportingFormContext } from 'contexts/InvestorReportingFormContext';

import useStyles from './styles';
import ClosedFund from './ClosedFund';
import AccordionTitle from './AccordionTitle';
import AccordionToggle from './AccordionToggle';

type Props = any;
type Indices = Array<number>;

const ClosedFundsList: React.FC<Props> = ({
  isViewPage,
  firmName,
  control,
  setValue,
}) => {
  const { classes, cx } = useStyles();
  const { fundInformation, submitDate } = useInvestorReportingFormContext();
  const [mountedFundIndices, setMountedFundIndices] = useState<Indices>([]);
  const [expandedFundIndices, setExpandedFundIndices] = useState<Indices>([]);

  useEffect(() => {
    const indices = fundInformation
      .map((fund, index) => (!fund.copyFund ? index : -1))
      .filter((index) => index >= 0);
    setMountedFundIndices(indices);
    setExpandedFundIndices(indices);
  }, [fundInformation]);

  const handleChangeSwitch = (index, isChecked) => {
    if (isChecked) {
      setExpandedFundIndices([...expandedFundIndices, index]);
      setMountedFundIndices([...mountedFundIndices, index]);
    } else {
      setExpandedFundIndices(
        expandedFundIndices.filter((item) => item !== index),
      );
    }
  };

  const handleAnimationComplete = (index) => {
    if (!expandedFundIndices.includes(index)) {
      setMountedFundIndices(
        mountedFundIndices.filter((item) => item !== index),
      );
    }
  };

  return (
    <>
      {fundInformation?.map((single, index) => (
        <Accordion
          key={index}
          expanded={expandedFundIndices.includes(index)}
          className={classes.customAccordion}
          slotProps={{
            transition: () => ({
              onExited: () => handleAnimationComplete(index),
            }),
          }}
        >
          <AccordionSummary
            className={cx(
              classes.cmAccHeader,
              classes.expends,
              classes.fundsAccHeader,
            )}
            expandIcon={
              <AccordionToggle
                item={single}
                index={index}
                handleChangeSwitch={handleChangeSwitch}
                isViewPage={isViewPage}
                setValue={setValue}
                control={control}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <AccordionTitle
              item={single}
              firmName={firmName}
              submitDate={submitDate}
            />
          </AccordionSummary>
          <AccordionDetails className={classes.cmAccDetail}>
            {mountedFundIndices.includes(index) && (
              <ClosedFund
                control={control}
                setValue={setValue}
                fund={single}
                index={index}
                isViewPage={isViewPage}
              />
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default ClosedFundsList;
